import React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import './PopupTemplates.scss';

/**
 * Split Layout Template - Left panel with table, right panel with chart
 * Used for popups that need a split view with header and side content
 */
const SplitLayoutTemplate = ({
  header,
  tableConfig,
  sideChart,
  pagination,
  onPaginationChange
}) => {
  const {
    rows = [],
    columns = [],
    totalElements = 0,
    gridProps = {}
  } = tableConfig || {};

  const defaultGridProps = {
    disableSelectionOnClick: true,
    pagination: true,
    paginationMode: "server",
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableColumnMenu: true,
    localeText: { noRowsLabel: "No Data Available" },
    sx: {
      maxHeight: 631,
      minWidth: 1200,
      maxWidth: 2000,
      overflowY: "auto",
      "& .MuiDataGrid-virtualScroller": {
        overflowY: "auto",
      },
    },
    ...gridProps
  };

  return (
    <div className="popup-content split-layout">
      {header}
      <div className="second-container">
        <div className="left-side-panel">
          <DataGrid
            rows={rows}
            columns={columns}
            rowCount={totalElements}
            page={pagination.page}
            pageSize={pagination.pageSize}
            onPageChange={(newPage) => onPaginationChange({ ...pagination, page: newPage })}
            onPageSizeChange={(newPageSize) => onPaginationChange({ ...pagination, pageSize: newPageSize })}
            {...defaultGridProps}
          />
        </div>
        <div className="right-side-panel">
          <div className="secondary-title">
            Locations
          </div>
          <div>
            {sideChart}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitLayoutTemplate;